import FormTemplate, {
  THEMES as FROM_TEMPLATE_THEMES_AUX,
} from '@/components/formTemplate';

export const FROM_TEMPLATE_THEMES = FROM_TEMPLATE_THEMES_AUX;
export const THEMES = {
  boxRadioButtonList: 'box-radio-button-list',
  inputList: 'input-list',
  textList: 'text-list',
};
function FormTemplateFake({
  withTitle = true,
  theme = THEMES.inputList,
  listLength = 4,
  withStep = false,
  formTemplateTheme = FROM_TEMPLATE_THEMES.NORMAL,
}) {
  return (
    <div className="form-template-fake">
      <FormTemplate theme={formTemplateTheme}>
        {withTitle && (
          <div className="title">
            {withStep && <div className="title--step skeleton" />}
            <div className="title--text skeleton " />
          </div>
        )}
        {theme === THEMES.radioButtonList && (
          <div className={theme}>
            {Array.from({ length: listLength }, (_, index) => (
              <div
                key={`input-fake-${index}`}
                className="input-fake skeleton"
              />
            ))}
          </div>
        )}
        {theme === THEMES.boxRadioButtonList &&
          Array.from({ length: listLength }, (_, index) => (
            <div key={`input-fake-${index}`}>
              {index > 0 && <div className="input-fake-title skeleton" />}
              <div className={theme}>
                <div
                  className={`input-fake-first-${
                    index % 2 === 0 ? 'even' : 'odd'
                  } skeleton `}
                />
                <div
                  className={`input-fake-second-${
                    index % 2 === 0 ? 'even' : 'odd'
                  } skeleton`}
                />
              </div>
            </div>
          ))}
        {theme === THEMES.inputList && (
          <div className={theme}>
            {Array.from({ length: listLength }, (_, index) => (
              <div key={`input-fake-${index}`} className="skeleton" />
            ))}
          </div>
        )}
        {theme === THEMES.textList && (
          <div className={theme}>
            {Array.from({ length: listLength }, (_, index) => (
              <div key={`text-fake-${index}`} className="skeleton" />
            ))}
          </div>
        )}
      </FormTemplate>
      <style jsx>
        {`
          .form-template-fake {
            margin-bottom: 12px;
          }
          .title {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 0px 0 8px 0px;
            .title--step {
              position: relative;
              right: 0px;
              top: 0px;
              width: 32px;
              height: 32px;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 8px;
            }
            .title--text {
              width: 200px;
              height: 20px;
              border-radius: 4px;
            }
          }
          .text-list > * {
            width: 100%;
            height: 20px;
            border-radius: 4px;
            margin: 0px 0 8px 0px;
          }
          .text-list > *:last-child {
            margin: 0px 0 0px 0px;
          }
          .input-list > * {
            width: 100%;
            height: 54px;
            border-radius: 4px;
            margin: 0px 0 8px 0px;
          }
          .input-list > *:last-child {
            margin: 0px 0 0px 0px;
          }

          .input-fake-title {
            width: 200px;
            height: 24px;
            border-radius: 4px;
            margin: 8px 0 8px 0;
          }
          .box-radio-button-list {
            display: flex;
            flex-direction: row;
            .input-fake-first-odd {
              width: 70px;
            }
            .input-fake-second-odd {
              width: 90px;
            }
            .input-fake-first-even {
              width: 100px;
            }
            .input-fake-second-even {
              width: 120px;
            }
          }
          .box-radio-button-list > * {
            height: 36px;
            border-radius: 8px;
            margin: 0px 8px 0px 0px;
          }
          @media screen and (min-width: 768px) {
            .input-list > * {
              height: 46px;
            }
          }
        `}
      </style>
    </div>
  );
}
export default FormTemplateFake;
